export default __webpack_public_path__ + "static/media/identity_and_access_management.c9b51026.png";